module.exports = __webpack_public_path__ + "img/hopways.927fcb74.webp";